import { render, staticRenderFns } from "./indicators.vue?vue&type=template&id=0177e310&scoped=true&"
import script from "./indicators.vue?vue&type=script&lang=ts&"
export * from "./indicators.vue?vue&type=script&lang=ts&"
import style0 from "./indicators.vue?vue&type=style&index=0&id=0177e310&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0177e310",
  null
  
)

export default component.exports